// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__1y3PW","header":"Header_header__3ywU1","profile":"Header_profile__3qOiu","rightPanel":"Header_rightPanel__1YQVx","button":"Header_button__308KK"};